import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const TaxPlanning = () => {
  return (
    <>
      <TopBanner content={"Tax Planning"} />
      <ContentWrapper>
        <div className="text-content">
          <h3>What is tax planning?</h3>
          <p>
            Tax liabilities can create a dent in your annual savings targets. To
            counter such instances, you can consider planning your taxes to save
            more and reduce your income tax liabilities. By availing of the tax
            deductions and benefits on various schemes like PPF, ELSS, health
            insurance, standard deduction, HRA, etc you can save more and be
            more tax efficient.
          </p>

          <h3>Importance of tax planning:</h3>
          <p>
            Tax planning is not just a year-end liability, it is a focal part of
            financial planning. Tax planning ensures you save your taxes while
            following the requirements of the income tax act, of 1961. While
            navigating through investment options, we prefer investing in the
            ones that give us tax benefits. Thus, tax planning when aligned with
            planning can help you save more as well as mitigate your tax
            liabilities for the long term.
          </p>

          <h3>Types of tax planning:</h3>
          <p>
            People most often believe paying and filing for taxes only help in
            reducing tax liabilities. But, tax planning has more to it. It can
            also mean investing in securities at the right time to reach your
            financial goals.
          </p>
          <p>Here are some of the types of tax planning in India:</p>
          <ol>
            <li>
              <strong>Short-term tax planning:</strong> This is done at the end
              of the financial year to reduce tax liabilities.
            </li>
            <li>
              <strong>Long-term tax planning:</strong> This is done at the
              beginning of the financial year to plan investments and savings
              for the entire year.
            </li>
            <li>
              <strong>Permissive tax planning:</strong> This is done by availing
              of all the exemptions, deductions, and rebates available under the
              Income Tax Act.
            </li>
            <li>
              <strong>Purposive tax planning:</strong> This is done to achieve a
              specific financial goal while minimizing tax liabilities.
            </li>
          </ol>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default TaxPlanning;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
